import {Stub} from "../feed/components";

const CareersPage = () => {
    return <Stub placeholder={'CareersPage'} />
}

export default CareersPage;
